/**
 * Perfume Subscription Widget
 *
 * Intercepts the page's add-to-cart button click (same pattern as
 * selling-plan-widget-optimized.liquid) and posts directly to /cart/add.js,
 * rather than relying on the native product-form picking up an injected
 * hidden field at submit time.
 *
 * Qty 1: 1 Hair Perfume -> single line item.
 * Qty 2: 2 Hair Perfumes, independent fragrance swatch per slot -> 2 line items.
 * Subscribe toggle attaches selling_plan: 2-month plan for qty 1, 4-month plan for qty 2.
 */

(function () {
  'use strict';

  var SEL_WIDGET = '.perfume-subscription-widget';

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';
    var localeMap = { EUR: 'de-DE', GBP: 'en-GB', USD: 'en-US', PLN: 'pl-PL', SEK: 'sv-SE' };
    var locale = localeMap[currency] || 'da-DK';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format((Number(cents) || 0) / 100);
  }

  function decodeJSON(raw, fallback) {
    try {
      return JSON.parse(raw);
    } catch (e) {
      return fallback;
    }
  }

  function initWidget(widget) {
    if (!widget || widget.dataset.pswInit === 'true') return;
    widget.dataset.pswInit = 'true';

    var productId = String(widget.dataset.productId || '');
    var variants = decodeJSON(widget.dataset.variants, []);
    if (!variants.length) return;

    var plan2mo = widget.getAttribute('data-plan-2mo') || '';
    var plan2moAdjustment = Number(widget.getAttribute('data-plan-2mo-adjustment') || 0);
    var plan2moAdjustmentType = widget.getAttribute('data-plan-2mo-adjustment-type') || 'percentage';
    var plan4mo = widget.getAttribute('data-plan-4mo') || '';
    var plan4moAdjustment = Number(widget.getAttribute('data-plan-4mo-adjustment') || 0);
    var plan4moAdjustmentType = widget.getAttribute('data-plan-4mo-adjustment-type') || 'percentage';
    var discountPercent = Number(widget.dataset.discountPercent || 0);
    var twoPackPrice = Number(widget.getAttribute('data-two-pack-price') || 0);

    function applyPlanAdjustment(basePrice, adjustment, adjustmentType) {
      if (!adjustment) return basePrice;
      var type = String(adjustmentType || 'percentage').toLowerCase();
      var adjusted = basePrice;
      if (type === 'percentage') {
        adjusted = basePrice * (1 - adjustment / 100);
      } else if (type === 'fixed_amount' || type === 'amount') {
        adjusted = basePrice - adjustment;
      }
      return Math.max(0, Math.round(adjusted));
    }

    var toggleCheckbox = widget.querySelector('.psw__toggle-checkbox');
    var toggleControl = widget.querySelector('.psw__toggle');

    var checkedTierRadio = widget.querySelector('.psw__tier-radio:checked');

    // If the first fragrance is sold out, default the single-perfume tier and
    // the two-pack's first slot to the second (available) fragrance instead.
    var defaultVariantId = (variants[0] && variants[0].available === false && variants[1] && variants[1].available !== false)
      ? variants[1].id
      : (variants[0] ? variants[0].id : null);

    var state = {
      qty: checkedTierRadio ? (Number(checkedTierRadio.value) || 1) : 1,
      slots: [
        defaultVariantId,
        defaultVariantId,
        variants[1] ? variants[1].id : (variants[0] ? variants[0].id : null)
      ],
      subscribed: false
    };

    function variantById(id) {
      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function updateDuft(slotIndex) {
      var slotEl = widget.querySelector('.psw__duft[data-psw-slot="' + slotIndex + '"]');
      if (!slotEl) return;
      var variant = variantById(state.slots[slotIndex]);
      if (!variant) return;

      var nameEl = slotEl.querySelector('.psw__duft-name-value');
      if (nameEl) nameEl.textContent = variant.title;

      var descEl = slotEl.querySelector('.psw__duft-desc');
      if (descEl) {
        var subtitle = variant.subtitle || '';
        descEl.textContent = subtitle;
        descEl.hidden = !subtitle;
      }

      var swatches = slotEl.querySelectorAll('.psw__swatch');
      for (var i = 0; i < swatches.length; i += 1) {
        var isActive = String(swatches[i].dataset.variantId) === String(variant.id);
        swatches[i].classList.toggle('active', isActive);
      }
    }

    function updateTier1Price() {
      var variant = variantById(state.slots[0]);
      if (!variant) return;
      var priceEl = widget.querySelector('[data-psw-price="1"]');
      var compareEl = widget.querySelector('[data-psw-compare="1"]');
      var badgeEl = widget.querySelector('[data-psw-badge="1"]');
      var base = Number(variant.price);

      if (state.subscribed && plan2mo) {
        var discounted = applyPlanAdjustment(base, plan2moAdjustment, plan2moAdjustmentType);
        if (priceEl) priceEl.textContent = formatMoney(discounted);
        if (compareEl) {
          compareEl.textContent = formatMoney(base);
          compareEl.hidden = false;
        }
        if (badgeEl) {
          var percent1 = Math.round(((base - discounted) / base) * 100);
          badgeEl.textContent = badgeEl.textContent.replace(/\d+/, String(percent1));
          badgeEl.hidden = percent1 <= 0;
        }
      } else {
        if (priceEl) priceEl.textContent = formatMoney(base);
        if (compareEl) compareEl.hidden = true;
        if (badgeEl) badgeEl.hidden = true;
      }
    }

    function updateTier2Price() {
      var v1 = variantById(state.slots[1]);
      var v2 = variantById(state.slots[2]);
      if (!v1 || !v2) return;

      var compareEl = widget.querySelector('[data-psw-compare="2"]');
      var priceEl = widget.querySelector('[data-psw-price="2"]');
      var badgeEl = widget.querySelector('[data-psw-badge="2"]');

      var base = Number(v1.price) + Number(v2.price);
      var oneTimePrice = twoPackPrice > 0
        ? twoPackPrice
        : (discountPercent > 0 ? Math.round(base - (base * discountPercent) / 100) : base);
      var finalPrice = oneTimePrice;

      if (state.subscribed && plan4mo) {
        finalPrice = applyPlanAdjustment(oneTimePrice, plan4moAdjustment, plan4moAdjustmentType);
        if (priceEl) priceEl.textContent = formatMoney(finalPrice);
        if (compareEl) {
          compareEl.textContent = formatMoney(oneTimePrice);
          compareEl.hidden = false;
        }
      } else {
        if (priceEl) priceEl.textContent = formatMoney(oneTimePrice);
        if (compareEl) compareEl.hidden = oneTimePrice >= base;
        if (compareEl) compareEl.textContent = formatMoney(base);
      }

      if (badgeEl && base > 0) {
        var effectivePercent = Math.round(((base - finalPrice) / base) * 100);
        badgeEl.textContent = badgeEl.textContent.replace(/\d+/, String(effectivePercent));
      }
    }

    function currentSellingPlanId() {
      if (!state.subscribed) return null;
      return state.qty === 2 ? (plan4mo || null) : (plan2mo || null);
    }

    function getProductForms() {
      var forms = [];
      document.querySelectorAll('product-form[data-product-id="' + productId + '"] form').forEach(function (form) {
        forms.push(form);
      });
      document.querySelectorAll('sticky-atc[data-product-id="' + productId + '"] form').forEach(function (form) {
        forms.push(form);
      });
      if (!forms.length) {
        var section = widget.closest('.product-template') || widget.closest('[data-section-type="product-page"]');
        if (section) {
          section.querySelectorAll('product-form form').forEach(function (form) {
            forms.push(form);
          });
        }
      }
      return forms;
    }

    function getProductAddButtons() {
      var list = [];
      document.querySelectorAll('product-form[data-product-id="' + productId + '"] button[name="add"]').forEach(function (b) {
        list.push(b);
      });
      document.querySelectorAll('sticky-atc[data-product-id="' + productId + '"] button[name="add"]').forEach(function (b) {
        list.push(b);
      });
      if (!list.length) {
        var section = widget.closest('.product-template') || widget.closest('[data-section-type="product-page"]');
        if (section) {
          section.querySelectorAll('button[name="add"]').forEach(function (b) {
            list.push(b);
          });
        }
      }
      if (!list.length) {
        document.querySelectorAll('button[name="add"]').forEach(function (b) {
          list.push(b);
        });
      }
      return list;
    }

    function syncMainForms() {
      if (state.qty === 2) return;

      var variant = variantById(state.slots[0]);
      if (!variant) return;

      getProductForms().forEach(function (form) {
        var idInput = form.querySelector('select[name="id"], input[name="id"]');
        if (idInput) {
          idInput.disabled = false;
          idInput.value = String(variant.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    function setQty(qty) {
      state.qty = qty;
      widget.querySelectorAll('.psw__tier').forEach(function (tierEl) {
        tierEl.classList.toggle('is-active', Number(tierEl.dataset.tier) === qty);
      });
      updateTier1Price();
      updateTier2Price();
      syncMainForms();
    }

    widget.querySelectorAll('.psw__tier-radio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        setQty(Number(radio.value) || 1);
      });
    });

    widget.querySelectorAll('.psw__swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var slotIndex = Number(btn.dataset.slot || 0);
        state.slots[slotIndex] = btn.dataset.variantId;
        updateDuft(slotIndex);
        updateTier1Price();
        updateTier2Price();
        syncMainForms();
      });
    });

    function setSubscribed(next) {
      state.subscribed = Boolean(next);
      if (toggleCheckbox) toggleCheckbox.checked = state.subscribed;
      updateTier1Price();
      updateTier2Price();
      syncMainForms();
    }

    if (toggleCheckbox) {
      toggleCheckbox.addEventListener('change', function () {
        setSubscribed(this.checked);
      });
    }

    if (toggleControl) {
      toggleControl.addEventListener('click', function (e) {
        if (e.target === toggleCheckbox) return;
        if (e.target.closest('[data-psw-info-trigger], [data-psw-info-popup]')) return;
        e.preventDefault();
        setSubscribed(!state.subscribed);
      });
    }

    var infoTrigger = widget.querySelector('[data-psw-info-trigger]');
    var infoPopup = widget.querySelector('[data-psw-info-popup]');
    var infoWrap = widget.querySelector('.psw__toggle-info-wrap');
    var infoArrow = widget.querySelector('.psw__info-popup-arrow');

    function positionInfoPopup() {
      if (!infoWrap || !infoPopup) return;
      var wrapRect = infoWrap.getBoundingClientRect();
      var popupWidth = infoPopup.offsetWidth;
      var margin = 12;

      var idealLeftViewport = wrapRect.left + (wrapRect.width / 2) - (popupWidth / 2);
      var minLeftViewport = margin;
      var maxLeftViewport = window.innerWidth - popupWidth - margin;
      var clampedLeftViewport = Math.min(Math.max(idealLeftViewport, minLeftViewport), maxLeftViewport);

      var offsetFromWrap = clampedLeftViewport - wrapRect.left;
      infoPopup.style.left = offsetFromWrap + 'px';
      infoPopup.style.transform = 'none';

      if (infoArrow) {
        var iconCenterViewport = wrapRect.left + (wrapRect.width / 2);
        var arrowLeft = iconCenterViewport - clampedLeftViewport - 6;
        arrowLeft = Math.min(Math.max(arrowLeft, 12), popupWidth - 12);
        infoArrow.style.left = arrowLeft + 'px';
      }
    }

    if (infoTrigger && infoPopup) {
      infoTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        infoPopup.hidden = !infoPopup.hidden;
        if (!infoPopup.hidden) positionInfoPopup();
      });

      document.addEventListener('click', function (e) {
        if (infoPopup.hidden) return;
        if (e.target === infoTrigger || infoTrigger.contains(e.target) || infoPopup.contains(e.target)) return;
        infoPopup.hidden = true;
      });
    }

    function buildCartItems(quantity) {
      var planId = currentSellingPlanId();

      if (state.qty === 2) {
        return [state.slots[1], state.slots[2]].filter(Boolean).map(function (id) {
          var item = { id: Number(id), quantity: 1 };
          if (planId) item.selling_plan = Number(planId);
          return item;
        });
      }

      var variant = variantById(state.slots[0]);
      if (!variant) return [];
      var item = { id: Number(variant.id), quantity: quantity || 1 };
      if (planId) item.selling_plan = Number(planId);
      return [item];
    }

    function triggerCartUpdate(data) {
      if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
        window.Shopify.onItemAdded(data);
        return;
      }
      if (window.MinimogEvents && typeof window.MinimogEvents.emit === 'function') {
        window.MinimogEvents.emit('ON_ITEM_ADDED', data);
      }
    }

    function addToCart(button) {
      var mainForm = button.closest('form');
      var quantity = 1;
      if (mainForm) {
        var formData = new FormData(mainForm);
        quantity = Number(formData.get('quantity')) || 1;
      }

      var items = buildCartItems(quantity);
      if (!items.length) return;

      // checkbox-cross-sell.js steps aside for buttons this widget owns (see
      // data-psw-atc below) — fold its checked items into this same request.
      var extraItems = (typeof window.getExtraCartItems === 'function') ? window.getExtraCartItems() : [];
      items = items.concat(extraItems);

      var originalText = button.textContent;
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items }),
        credentials: 'same-origin'
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data && data.status) {
            console.error('[perfume-subscription-widget] cart add error:', data.description || data.message);
            return;
          }
          triggerCartUpdate(data);
          if (extraItems.length && typeof window.resetExtraCartItems === 'function') window.resetExtraCartItems();
        })
        .catch(function (err) {
          console.error('[perfume-subscription-widget] cart add failed:', err.message);
        })
        .finally(function () {
          button.disabled = false;
          button.textContent = originalText;
        });
    }

    window.__pswAtcBound = window.__pswAtcBound || {};
    if (!window.__pswAtcBound[productId]) {
      window.__pswAtcBound[productId] = true;
      getProductAddButtons().forEach(function (button) {
        button.setAttribute('data-psw-atc', 'true');
        button.addEventListener('click', function (event) {
          event.preventDefault();
          addToCart(button);
        });
      });
    }

    updateDuft(0);
    updateDuft(1);
    updateDuft(2);
    updateTier1Price();
    updateTier2Price();
    syncMainForms();
  }

  function boot() {
    document.querySelectorAll(SEL_WIDGET).forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());
